var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "panel pt-1 pb-3" }, [
      _vm.isResourcesLoading
        ? _c("div", [
            _c(
              "div",
              { staticClass: "px-5" },
              [_c("resources-loading-skeleton")],
              1
            )
          ])
        : _c("div", { staticClass: "panel-body-lg pb-4" }, [
            _c("div", { staticClass: "panel-header pb-2" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm.isLoadingError
                ? _c("div", { staticClass: "alert alert-error mt-3" }, [
                    _vm._v("\n          " + _vm._s(_vm.errorMsg) + "\n        ")
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row pr-lg-5" },
              _vm._l(_vm.resources, function(resource, i) {
                return _c(
                  "div",
                  { key: i, staticClass: "resources-wrapper col-12 col-xl-6" },
                  [
                    _c(
                      "div",
                      [
                        _c("resources-card", {
                          attrs: { "resource-data": resource }
                        })
                      ],
                      1
                    )
                  ]
                )
              }),
              0
            )
          ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pt-4 pb-1" }, [
      _c("h2", [_vm._v("Employee resources")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bd3ed48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bd3ed48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/resources/ResourcesPanel.vue
// module id = null
// module chunks = 